import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, HomeworkEvaluationOptions } from "../../../../../../../_helpers/Helpers";
import { useStudentsUIContext } from "../StudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { studentNumber, studentName, homeworkStatus, evaluationExplanation } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  const homeworkId = queryParams.filter.homeworkId;
  const newQueryParams = { ...queryParams };
  const filter = { homeworkId, studentNumber, studentName, homeworkStatus, evaluationExplanation };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StudentsFilter() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      setQueryParams: studentsUIContext.setQueryParams,
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const homeworkEvaluationOptions = FilterOptions.concat(HomeworkEvaluationOptions);

  return (
    <Formik
      initialValues={{
        studentNumber: "",
        studentName: "",
        evaluationExplanation: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentNumber"
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Adı Soyadı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={homeworkEvaluationOptions}
                value={values.homeworkStatus}
                placeholder="Durum"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("homeworkStatus", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Durum</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="evaluationExplanation"
                placeholder="Açıklama"
                onBlur={handleBlur}
                value={values.evaluationExplanation}
                onChange={(e) => {
                  setFieldValue("evaluationExplanation", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Değerlendirme Açıklaması</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}